import React from 'react';

import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  Button,
  HeaderText,
  Stack,
} from '../../../ui';

import {
  CloseIcon,
  RadialGradientCameraIcon,
} from '../../../ui/Icons';

import analytics from '../../../../modules/analytics';
import stateManager from '../../../../modules/user/stateManager';
import { useMount } from '../../../../hooks';
import PortalOverlay, { PortalOverlayModal } from '../../../ui/PortalOverlay';
import { INCENTIVE_MODAL_KEY } from '../index';

type IncentiveToAddModalProps = {
  onClose: () => void,
};

export const IncentiveToAddModal: React.FC<IncentiveToAddModalProps> = ({
  onClose,
}) => {
  useMount(() => {
    analytics.track('pro_clients_instagrampromo_view');
    stateManager.addAction(INCENTIVE_MODAL_KEY, true);
  });

  return (
    <PortalOverlay
      name="incentive-to-add-modal"
    >
      <PortalOverlayModal position="dialog">
        <Box
          padding={16}
          color={colors.whiteWash}
        >
          <Box
            flexDirection="row-reverse"
            paddingBottom={24}
          >
            <Button
              appearance="none"
              size="medium"
              onClick={onClose}
              testID="incentive-to-add-modal-close-button"
              clickTracking="pro_clients_instagrampromo_dismiss"
            >
              <CloseIcon
                color={colors.ash}
                height={20}
                width={20}
              />
            </Button>
          </Box>
          <Stack
            paddingTop={8}
            paddingBottom={32}
            space={32}
            alignItems="center"
            paddingX={12}
            style={{
              width: '100%',
            }}
          >
            <Box testID="incentive-to-add-modal-icon-wrapper">
              <RadialGradientCameraIcon
                width={48}
                height={48}
              />
            </Box>
            <HeaderText
              level={2}
              textAlign="center"
            >
              Invite 5 Clients and enter for a chance to be featured on the StyleSeat Instagram!
            </HeaderText>
          </Stack>
          <Button
            onClick={onClose}
            clickTracking="pro_clients_instagrampromo_thankyou_click"
            testID="incentive-to-add-modal-thankyou-button"
          >
            Awesome, Thank You
          </Button>
        </Box>
      </PortalOverlayModal>
    </PortalOverlay>
  );
};
